/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router";

import {
  singleService,
  homeDictionary,
} from "../../../Features/HomeApi/HomeSlice";
import { openModal, openLoginForm } from "../../../Features/ViewSlice";

import DictionaryPage from "../../DashboardView/Container/DictionaryPage/DictionaryPage";
import PageHeadings from "../PageHeadings";
import SEO from "../Seo/Seo";

const ModuleDictionary = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const token = useSelector((state) => state.auth?.currentUser?.token);
  const dictionaryItem = useSelector((state) => state.home.allDictionary);
  const errorHandle = useSelector((state) => state.home.errorHandle);

  const selectedService = useSelector(
    (state) => state.home.selectedSingleService,
    shallowEqual,
  );

  const seoData = selectedService?.seo_data;

  const [page, setPage] = useState(1);

  // 🔹 Fetch Dictionary service (ID: 3)
  useEffect(() => {
    dispatch(singleService({ id: 3 }));
  }, [dispatch]);

  // 🔹 Fetch dictionary list
  useEffect(() => {
    if (!errorHandle) {
      dispatch(homeDictionary({ page }));
    }
  }, [dispatch, page, errorHandle]);

  const openLogin = (e) => {
    e.preventDefault();
    dispatch(openModal("loginView"));
    dispatch(openLoginForm());
  };

  const goToDashboard = () => {
    navigate("/dashboard");
  };

  return (
    <>
      {/* 🔥 SEO maintained strictly from API */}
      {seoData && (
        <SEO
          title={seoData.meta_title}
          description={seoData.meta_description}
          keywords={seoData.meta_keywords?.join(", ")}
          path={seoData.canonical_url}
        />
      )}

      {dictionaryItem && (
        <>
          <PageHeadings item={selectedService} hasIcon />

          <Container>
            <div className="grammar-container home__dictionary">
              <DictionaryPage
                setPage={setPage}
                datas={dictionaryItem}
                type="home"
              />
            </div>
          </Container>
        </>
      )}
    </>
  );
};

export default ModuleDictionary;
